import { dataHook } from '../../testkitUtils/utils';
import {
  ButtonNextDriver,
  buttonNextDriverFactory,
} from '../internal/WixUiCoreComponents/components/CoreButtonNext/CoreButtonNext.uni.driver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { DataHooks } from './consts';

export interface StatesButtonDriver extends ButtonNextDriver {
  checkIconExists(): Promise<boolean>;
}

export const statesButtonDriverFactory = (
  base: UniDriver,
): StatesButtonDriver => {
  return {
    ...buttonNextDriverFactory(base),
    checkIconExists: () => base.$(dataHook(DataHooks.checkIcon)).exists(),
  };
};
